import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ApplicationForm from "@/pages/ApplicationForm";
import SuccessPage from "@/pages/SuccessPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Applications from "@/pages/admin/Applications";
import ApplicationDetail from "@/pages/admin/ApplicationDetail";
import Settings from "@/pages/admin/Settings";
import Diagnostics from "@/pages/admin/Diagnostics";
import ChangePassword from "@/pages/admin/ChangePassword";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm tracking-widest uppercase">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.must_change_password) return <Navigate to="/admin/change-password" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<ApplicationForm />} />
          <Route path="/success/:appNo" element={<SuccessPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/change-password" element={<ChangePassword />} />
          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="applications" element={<Applications />} />
            <Route path="applications/:id" element={<ApplicationDetail />} />
            <Route path="settings" element={<Settings />} />
            <Route path="diagnostics" element={<Diagnostics />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
